<template>
  <div class="tm-details-hero-loading">
    <div class="d-flex justify-between align-center">
      <div class="d-flex align-center">
        <tm-skeleton-avatar
          v-if="!isMobile"
          custom-size="48px"
          dark
          class="mr-4"
        />

        <div>
          <tm-skeleton
            type="QChip"
            width="173px"
            height="20px"
            dark
            class="mb-2"
          />
          <tm-skeleton
            width="105px"
            dark
            height="12px"
            type="QChip"
          />
        </div>
      </div>
      <div class="d-flex gt-sm">
        <tm-skeleton
          v-for="i in preparedBtnCount"
          :key="i"
          dark
          width="93px"
          height="22px"
          type="QChip"
          class="ml-2"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import { useBreakpoints } from '@/composition/breakpoints'
import TmSkeletonAvatar from '@/components/shared/skeletons/TmSkeletonAvatar.vue'

const props = defineProps<{
  btnCount?: number
}>()

const { isMobile, isTablet, isLargeLaptop } = useBreakpoints()

const preparedBtnCount = computed(() => {
  if (props.btnCount !== undefined) {
    return props.btnCount
  }
  if (isTablet.value) {
    return 2
  }
  if (isLargeLaptop.value) {
    return 3
  }

  return 5
})
</script>

<style lang="scss" scoped>
.tm-details-hero-loading {
  padding: $detailsHeroPadding;
  background: $blue100;
  border-radius: $border-radius-md-x;

  @include media-sm-x-max {
    padding: $detailsHeroPaddingMobile;
  }
}
</style>
